<template>
  <select-input
    class="dropdown-transparent icon-dropdown tag-dropdown tags-input"
    :allow-create="allowCreate"
    :allow-select-all="allowSelectAll"
    :right="right"
    :boundary="boundary"
    :multi="multi"
    :value="inputValue"
    :options="getTagsList"
    :searchable="true"
    :search-max-length="50"
    :use-checkboxes="true"
    @input="onInput"
    @hidden="$emit('hidden')"
    @shown="$emit('shown')"
  >
    <template slot="button-content">
      <slot>
        <div
          class="manage-tags i-text-subheading-3 d-flex flex-row i-pl-4 i-pr-2 i-pt-2 i-pb-2"
          @mouseenter="hovering = true"
          @mouseleave="hovering = false"
        >
          <span class="neutral">Manage tags</span>
          <i-icon
            symbol="small-chevron-down"
            :size="16"
            :class="hovering ? `i-text-neutral-110` : `i-text-neutral-90`"
          ></i-icon>
        </div>
      </slot>
    </template>
  </select-input>
</template>

<script>
import { SelectInput } from '@inscribe/ui-kit';
import { iIcon } from '@inscribe/signal';
import { mapGetters } from 'vuex';

export default {
  components: {
    iIcon,
    'select-input': SelectInput,
  },
  props: {
    allowCreate: {
      type: Boolean,
      default: true,
    },
    allowSelectAll: {
      type: Boolean,
      default: false,
    },
    boundary: {
      type: [String, Element],
      default: () => document.body,
    },
    multi: {
      type: Boolean,
      default: true,
    },
    right: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      hovering: false,
    };
  },
  computed: {
    ...mapGetters({
      getTagsList: 'getTagsList',
    }),
    inputValue() {
      return this.multi
        ? this.value.map((tag) => tag.value)
        : this.value && this.value.value;
    },
  },
  methods: {
    onInput(value, valueOption) {
      this.$emit('input', this.multi ? value : valueOption);
    },
  },
};
</script>
<style lang="scss">
.dropdown-transparent.tags-input {
  align-items: center;

  .btn {
    padding: 0;

    &.btn-secondary.dropdown-toggle:hover {
      text-decoration: none;
    }

    .manage-tags {
      height: 22px;
      background: $light-neutral-30;
      border-radius: 100px;
      color: $light-neutral-120;
    }
  }
}
</style>
